var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    height: "32px",
    width: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.864 64h23.28l-12.375-25.877zm10.946-62.974-59.257 20.854 9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635zm-15.766 73.974-7.265 18.176-13.581 0.056 36.608-81.079s26.531 56.561 38.19 81.417l-13.074-0.287-8.042-18.58-17.173 0.082z",
    fill: "#c4473a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.6c56bd1890f169faa483afa5bc009a2c.svg";
export { ForwardRef as ReactComponent };